import vehicleEvents from "./components/vehicleEvents.vue";
import categories from "./components/categories.vue";
import drivingLicenseTypes from "./components/drivingLicenseTypes.vue";
import poiCategories from "./components/poiCategories.vue";
import vehicleStates from "./components/vehicleStates.vue";
import divisions from "./components/divisions.vue";
import groups from "./components/groups.vue";

import { mapGetters } from "vuex";

export default {
	components: {
		vehicleEvents,
		categories,
		drivingLicenseTypes,
		poiCategories,
		vehicleStates,
		groups,
		divisions
	},

	data: function() {
		return {
			loading: false,
			hasDivisions: false
		};
	},

	created() {
		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;
	},
	mounted() {},

	/* metodi */
	methods: {},

	/* visualizzazione risultati */
	computed: {
		...mapGetters(["settings"])
	}
};
